import type { AsyncState } from '../../../platform/async/Async'
import { isClose, isOver, type Envelope } from '../../budget/useBudgets'

export const BUDGET_ROWS = 6

/**
 * `useBudgets()`'s state as the widget's: the active MONTHLY envelopes (the
 * subtitle says so; weekly and yearly live on `/budget`), over-budget first,
 * then close, then the rest, each group in M4's own order, at most six.
 * Ordering and selection only — every flag and percentage is the server's.
 * `stale` passes through with its `asOf`: budgets is a synced surface (E5).
 */
export function toBudgetState(state: AsyncState<Envelope[]>): AsyncState<Envelope[]> {
  if (state.status !== 'success' && state.status !== 'stale') return state
  const monthly = state.data.filter((e) => e.isActive && e.period === 'monthly')
  if (monthly.length === 0) return { status: 'empty' }
  const data = [...monthly.filter(isOver), ...monthly.filter(isClose), ...monthly.filter((e) => !isOver(e) && !isClose(e))].slice(
    0,
    BUDGET_ROWS,
  )
  return state.status === 'stale' ? { status: 'stale', data, asOf: state.asOf } : { status: 'success', data }
}
